import { FC } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFlask } from "@fortawesome/free-solid-svg-icons";

export const InDevelopment: FC = () => {
  return <div className={"inline-flex items-center bg-indigo-500 px-3 rounded-full text-white mx-3 font-medium"}>
    <FontAwesomeIcon icon={faFlask} className={"text-xs mx-1"} />&nbsp;<span className={"text-xs"}>In Development</span>
  </div>
}
